<app-data-table [title]="title" [columns]="tableColumns" [filters]="tableFilters" [items]="items" [totalCount]="count"
    [page]="page" [pageSize]="pageSize" [loading]="loading" [filterValues]="tableFilterValues" createLabel="Aggiungi"
    [createLink]="['/admin/founders/create']" [editLink]="editLink" (pageChange)="handlePageChange($event)"
    (search)="onTableSearch($event)" (delete)="onDelete($event)">
</app-data-table>

{{ error }}